import type { ICurrency } from '~/types'
import { useCurrencyStore } from '~/stores/currencies'

/**
 * Get specific field value from currency by ID
 * @param id - Currency ID
 * @param field - Field name of the currency (must be keyof ICurrency)
 * @returns Field value or undefined
 */
export function useCurrencyProp<K extends keyof ICurrency>(
  id: number,
  field: K
): ICurrency[K] | undefined {
  const store = useCurrencyStore()
  const currency = store.list.find((c) => c.id === id)
  return currency?.[field]
}
